import {Component, h, State, Event, EventEmitter, Fragment} from '@stencil/core';
import {baseUri, translate} from "../../../utils/utils";
import {shopIntegrationState} from "../../../utils/store";

@Component({
  tag: 'ike-avatar',
  styleUrl: 'ike-avatar.scss',
  shadow: false,
})
export class IkeAvatar {
  @State() cart: any;
  @State() name: any;
  @State() color = "#7974B4";

  /**
   * GTM trigger
   */
  @Event() ike_user_logout: EventEmitter;

  /**
   * Display notification
   */
  @Event() ike_notification: EventEmitter;
  @Event() getUtils: EventEmitter;
  private utils: any;

  private unsub = [];

  componentWillLoad() {
    this.getUtils.emit(utils=>this.utils=utils);
    this.unsub.push(this.utils.cart(cart => this.cart = cart));
    if (this.cart?.customer?.name) {
      this.setAvatar(this.cart.customer.name);
    }
    this.utils.store.onChange('cart', cart => this.setAvatar(cart?.customer?.name));
  }

  disconnectedCallback(){
    this.unsub.forEach(call=>call())
  }

  private setAvatar(name) {
    if (name && name.length > 2) {
      this.name = name.split(' ');
      this.name = this.name.map(val => val.charAt(0).toUpperCase()).slice(0, 2).join('');
    } else {
      this.name = (this.name || '').toUpperCase();
    }
    let infomaniakColors = ['#7974B4', '#3990BB', '#00A1B9', '#30abff', '#029688', '#3CB572', '#FFC300', '#ED2C6E', '#D9283A'];
    if (/^[A-C]*$/.test(this.name.charAt(0))){
      this.color = infomaniakColors[1];
    }
    if (/^[D-F]*$/.test(this.name.charAt(0))){
      this.color = infomaniakColors[2];
    }
    if (/^[G-I]*$/.test(this.name.charAt(0))){
      this.color = infomaniakColors[3];
    }
    if (/^[J-L]*$/.test(this.name.charAt(0))){
      this.color = infomaniakColors[4];
    }
    if (/^[M-O]*$/.test(this.name.charAt(0))){
      this.color = infomaniakColors[5];
    }
    if (/^[P-S]*$/.test(this.name.charAt(0))){
      this.color = infomaniakColors[6];
    }
    if (/^[T-V]*$/.test(this.name.charAt(0))){
      this.color = infomaniakColors[7];
    }
    if (/^[X-Z]*$/.test(this.name.charAt(0))){
      this.color = infomaniakColors[8];
    }
  }

  private logout(){
    this.utils.http('get','/user/logout').then(cart => {
      this.utils.storage.remove('user_token');
      this.ike_notification.emit(['success',translate("Deconnexion reussi")])
      this.ike_user_logout.emit(cart)
      window.location.reload()
    }).catch(() => {
      this.ike_notification.emit(['error',translate("Une erreur est survenue")]);
    });
  }

  render() {
    return <Fragment>
      {shopIntegrationState.isEmbedded && <div>
        {this.utils.isUserLogged() ?
          <ike-dropdown placement="bottom">
            <div slot="trigger" class="avatar" style={{'background-color':this.color, 'color':'white'}}>
              {this.name}
            </div>
            <div slot="content">
              <ike-link class="dropdown__link" url="/profile">
                <i class="icon icon-single-neutral-circle dropdown__icon"/>
                <p class="text-4 dropdown__text">{translate("Compte client")}</p>
              </ike-link>
              <div class="dropdown__link">
                <i class="icon icon-logout dropdown__icon"/>
                <a onClick={() => this.logout()} class="text-4 dropdown__text">{translate("Deconnexion")}</a>
              </div>
            </div>
          </ike-dropdown>
          :
          <ike-link url="/login" class="button btn-cart"><i class="icon-single-neutral-circle" aria-label={translate('Se connecter')}/><span class="text-2 responsive">{translate('Se connecter')}</span></ike-link>
        }
      </div>}
      {!shopIntegrationState.isEmbedded &&
        <a href={`${baseUri()}/account`}>
          <i class="icon-single-neutral-circle" aria-label={translate('Se connecter')}/>
          <span class="text-2 responsive">
            {translate('Se connecter')}
          </span>
        </a>
      }
    </Fragment>;
  }
}
